import loadable from '@loadable/component';
import React from 'react';
import { useCart } from '../../hooks/useCart';
import { useCheckout } from '../../hooks/useCheckout';
import { Loading } from '../Loading';

const CheckoutGiftSectionConfigurator = loadable(
  () => import('./CheckoutGiftSectionConfigurator'),
  {
    fallback: <Loading />,
    resolveComponent: exports => exports.CheckoutGiftSectionConfigurator
  }
);

export const CheckoutGiftSection = () => {
  const {
    cart: {
      attributes: { isGiftingAllowed }
    }
  } = useCart();
  const { isShippingAddressSelected } = useCheckout();

  if (!isGiftingAllowed) return null;

  if (!isShippingAddressSelected) return null;

  return <CheckoutGiftSectionConfigurator />;
};
